import { post, get, serverUrl } from './http.js';

/**
 * 服务器地址
 */
export { serverUrl };

/**
 * 登录
 */
export const fetchLogin = (data) => post('/api/msp/user/login', data);

/**
 * 上传附件 返回File对象
 */
export const fetchUploadFile = (data, others) =>
    post('/api/msp/file/uploadfile', data, { ...others, unlimitedTime: true });

/**
 * 上传附件 返回OSS路径
 */
export const fetchUploadFileToPath = (data, others) =>
    post('/api/msp/file/upload', data, { ...others, unlimitedTime: true });

/**
 * 上传视频
 */
export const fetchUploadVideo = (data, others) =>
    post('/api/File/UploadVideo', data, { ...others, unlimitedTime: true });

/**
 * 根据OSS路径获取Url
 */
export const fetchGetImgPath = (data) => get('/api/File/GetOssUrlByOssPath', data);

/**
 * 返回附件预览相对路径
 */
export const fetchFilePreview = (data) => get('/api/msp/file/preview', data);

/**
 * 文件解析
 */
export const fetchAnalysis = (data) => get('/api/msp/file/analysis', data);

/**
 * 获取用户列表
 */
export const fetchUserList = (data) => post('/api/msp/user/queryuser', data);

/**
 * 获取用户列表 不需要Token
 */
export const fetchUserListNoToken = (data) => post('/api/msp/user/queryuserlist', data);

/**
 * 新增用户
 */
export const fetchAddUser = (data) => post('/api/msp/user/adduser', data);

/**
 * 编辑用户
 */
export const fetchUpdateUser = (data) => post('/api/msp/user/updateuser', data);

/**
 * 修改用户状态
 */
export const fetchUpdateUserState = (data) => post('/api/msp/user/updateuserstatus', data);

/**
 * 删除用户
 */
export const fetchDelUser = (data) => post(`/api/User/Delete/${data}`);

/**
 * 获取单个用户
 */
export const fetchGetUser = (data) => post(`/api/msp/user/getuser`, data);

/**
 * 获取用户自己的信息
 */
export const fetchGetUserSelfInfo = (data) => post(`/api/msp/user/getmyinfo`, data);

/**
 * 修改用户自己的信息
 */
export const fetchUpdateUserSelfInfo = (data) => post(`/api/msp/user/updatemyinfo`, data);

/**
 * 修改用户自己的密码
 */
export const fetchUpdateUserSelfPassword = (data) => post(`/api/msp/user/updatepassword`, data);

/**
 * 获取职位列表数字
 */
export const fetchGetCaseListCount = (data) => post(`/api/msp/project/getlistcount`, data);

/**
 * 获取职位列表
 */
export const fetchGetCaseList = (data) => post(`/api/msp/project/query`, data);

/**
 * 获取职位日志
 */
export const fetchGetCaseLog = (data) => post(`/api/fesco/case/getcaseprocess`, data);

/**
 * 获取职位详情
 */
export const fetchGetCaseInfo = (data) => post(`/api/msp/project/getcase`, data);

/**
 * 获取系统标签
 */
export const fetchGetSystemTags = (data) => post(`/api/common/common/gettag`, data);

/**
 * 获取候选人列表数字
 */
export const fetchGetCandidateListCount = (data) => post(`/api/msp/person/getpersonlistcount`, data);

/**
 * 获取候选人列表
 */
export const fetchGetCandidateList = (data) => post(`/api/msp/person/queryperson`, data);

/**
 * 获取人才详情
 */
export const fetchGetPersonInfo = (data) => get(`/api/msp/person/get/${data}`);

/**
 * 获取候选人详情(Fesco)
 */
export const fetchGetPersonInfoNoToken = (data) => get(`/api/msp/person/getdetail/${data}`);

/**
 * 修改候选人
 */
export const fetchUpdatePerson = (data) => post(`/api/msp/person/update`, data);

/**
 * 获取候选人流程数量
 */
export const fetchGetPersonProgressCount = (data) => post(`/api/msp/person/getpersonprogresscount`, data);

/**
 * 获取候选人推荐日志
 */
export const fetchGetPersonRecommendLog = (data) => post(`/api/msp/person/getpersonrecommendlog`, data);

/**
 * 获取首页职位数量
 */
export const fetchGetHomeCaseCount = (data) => post(`/api/msp/project/gethomecount`, data);

/**
 * 获取首页职位候选人数量
 */
export const fetchGetHomeCandidateCount = (data) => post(`/api/msp/project/gethomecandidatecount`, data);

/**
 * 获取公司信息
 */
export const fetchGetCompanyInfo = (data) => post(`/api/msp/project/getcompany`, data);

/**
 * 根据职位获取职位候选人数量
 */
export const fetchGetCaseCandidateCount = (data) => post(`/api/msp/project/getcasecandidatecount`, data);

/**
 * 推荐候选人查重
 */
export const fetchCheckRepeat = (data) => get('/api/msp/person/recommendrepeatquery', data);

/**
 * 推荐候选人
 */
export const fetchRecommendPerson = (data) => post(`/api/msp/person/recommendperson`, data);

/**
 * KPI报表
 */
export const fetchQueryKpiReport = (data) => post(`/api/msp/report/querykpireport`, data);

/**
 * 成单报表
 */
export const fetchQueryOrderReport = (data) => post(`/api/msp/report/queryorderreport`, data);

/**
 * 获取职位消息的未读数量
 */
export const fetchGetCaseMessageCount = (data) => post(`/api/msp/message/getcasemessagecount`, data);

/**
 * 获取职位消息列表
 */
export const fetchQueryCaseMessage = (data) => post(`/api/msp/message/querycasemessage`, data);

/**
 * 获取推荐消息的未读数量
 */
export const fetchGetCandidateMessageCount = (data) => post(`/api/msp/message/getcandidatemessagecount`, data);

/**
 * 获取推荐消息列表
 */
export const fetchQueryCandidateMessage = (data) => post(`/api/msp/message/querycandidatemessage`, data);
